import { render, staticRenderFns } from "./EditableFileAttachmentsList.view.vue?vue&type=template&id=22bc8405&"
import script from "./EditableFileAttachmentsList.view.vue?vue&type=script&lang=js&"
export * from "./EditableFileAttachmentsList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22bc8405')) {
      api.createRecord('22bc8405', component.options)
    } else {
      api.reload('22bc8405', component.options)
    }
    module.hot.accept("./EditableFileAttachmentsList.view.vue?vue&type=template&id=22bc8405&", function () {
      api.rerender('22bc8405', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/EditableFileAttachmentsList.view.vue"
export default component.exports